export function extendResolversFromInterfaces(schema, resolvers) {
    const typeNames = Object.keys({
        ...schema.getTypeMap(),
        ...resolvers,
    });
    const extendedResolvers = {};
    typeNames.forEach(typeName => {
        const typeResolvers = resolvers[typeName];
        const type = schema.getType(typeName);
        if ('getInterfaces' in type) {
            const interfaceResolvers = type.getInterfaces().map(iFace => resolvers[iFace.name]);
            extendedResolvers[typeName] = Object.assign({}, ...interfaceResolvers, typeResolvers);
        }
        else if (typeResolvers != null) {
            extendedResolvers[typeName] = typeResolvers;
        }
    });
    return extendedResolvers;
}
//# sourceMappingURL=extendResolversFromInterfaces.js.map